import React from 'react'
import './header.css'
export default function header() {
  return (
    <div >
        <div className='header-align'>
          
            <a href className='button1'>Buthmi</a>
            <a href className='button'>Home</a>
            <a href className='button'>Skills</a>
            <a href className='button'>Projects</a>
            <a href className='button'>Contact</a>
        </div>
    </div>
   
  )
}
